import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Helmet } from 'react-helmet';
import qs from 'qs';
import withWidth from '@material-ui/core/withWidth';

import { getFormValues, change } from 'redux-form';

import Layout from 'components/common/Layout';
import Progress from 'components/common/Progress';
import InventoryNavigation from 'components/inventory/InventoryNavigation';
import InventoryFilter from 'components/inventory/InventoryFilter';
import InventoryTable from 'components/inventory/InventoryTable';
import InventoryCreateEditDialog from 'components/inventory/InventoryCreateEditDialog';
import VendorCreateEditDialog from 'components/vendor/VendorCreateEditDialog';
import InventoryCategoryCreateEditDialog from 'components/settings/InventoryCategoryCreateEditDialog';
import InventoryConditionCreateEditDialog from 'components/settings/InventoryConditionCreateEditDialog';
import InventoryWarehouseCreateEditDialog from 'components/settings/InventoryWarehouseCreateEditDialog';

import { fetchInventories, clearInventories } from 'redux/modules/inventory';
import { addRouterParamsPageSettings } from 'redux/modules/routerParams';
import { fetchBusiness } from 'redux/modules/business';

import { getFilterChangeTypes } from 'utils/filterChangeTypes';
import objectDiff from 'utils/objectDiff';
import throttle from 'utils/throttle';

import { appTitle, titleSeparator } from 'config/helmetSettings';

class Inventory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inventoryCreateDialogOpen: false,
      vendorCreateDialogOpen: false,
      inventoryCreateFormValues: null,
      categoryCreateDialogOpen: false,
      conditionCreateDialogOpen: false,
      warehouseCreateDialogOpen: false,
      mobileFilterExpanded: ['xs', 'sm'].indexOf(props.width) === -1,
      limit: 10,
      offset: 0,
    };

    this.onRequest = this.onRequest.bind(this);
    this.onCreateButtonClick = this.onCreateButtonClick.bind(this);
    this.onInventoryCreateDialogEnter = this.onInventoryCreateDialogEnter.bind(this);
    this.onInventoryCreateDialogClose = this.onInventoryCreateDialogClose.bind(this);
    this.onVendorCreate = this.onVendorCreate.bind(this);
    this.onVendorCreateDialogSubmitSuccess = this.onVendorCreateDialogSubmitSuccess.bind(this);
    this.onVendorCreateDialogClose = this.onVendorCreateDialogClose.bind(this);
    this.onCategoryCreate = this.onCategoryCreate.bind(this);
    this.onCategoryCreateDialogSubmitSuccess = this.onCategoryCreateDialogSubmitSuccess.bind(this);
    this.onCategoryCreateDialogClose = this.onCategoryCreateDialogClose.bind(this);
    this.onConditionCreate = this.onConditionCreate.bind(this);
    this.onConditionCreateDialogSubmitSuccess =
      this.onConditionCreateDialogSubmitSuccess.bind(this);
    this.onConditionCreateDialogClose = this.onConditionCreateDialogClose.bind(this);
    this.onWarehouseCreate = this.onWarehouseCreate.bind(this);
    this.onWarehouseCreateDialogSubmitSuccess =
      this.onWarehouseCreateDialogSubmitSuccess.bind(this);
    this.onWarehouseCreateDialogClose = this.onWarehouseCreateDialogClose.bind(this);
    this.onSortingChange = this.onSortingChange.bind(this);
    this.onMobileFilterBottonClick = this.onMobileFilterBottonClick.bind(this);
    this.onTableScroll = this.onTableScroll.bind(this);

    this.onThrottledRequest = throttle(this.onRequest, 2000, false, true);
  }

  componentWillMount() {
    this.props.actions.clearInventories();
  }

  componentDidMount() {
    this.onRequest();
    this.props.actions.fetchBusiness({
      triggerLoading: false,
    });
  }

  componentWillReceiveProps(nextProps) {
    const { filters, width } = this.props;
    const { limit, offset } = this.state;
    const filtersChanged =
      nextProps.filters['Product Name / HCPCS Code'] !== filters['Product Name / HCPCS Code']
      || nextProps.filters.Model !== filters.Model
      || nextProps.filters['Vendor ID'] !== filters['Vendor ID']
      || nextProps.filters['Facility ID'] !== filters['Facility ID']
      || nextProps.filters['Category ID'] !== filters['Category ID']
      || nextProps.filters.Custom !== filters.Custom
      || nextProps.filters['Is Active'] !== filters['Is Active'];
    let newOffset = offset;
    if (filtersChanged) {
      newOffset = 0;
    }

    if (newOffset !== offset) {
      this.setState({ offset: newOffset });
    }

    if (nextProps.width !== width) {
      this.setState({
        mobileFilterExpanded: ['xs', 'sm'].indexOf(nextProps.width) === -1,
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return ((Object.keys(objectDiff(this.props, nextProps)).length +
      Object.keys(objectDiff(this.state, nextState)).length) > 0);
  }

  componentDidUpdate(prevProps, prevState) {
    const { filters, sortBy, sort, inventory, count, loading } = this.props;
    const { limit, offset } = this.state;
    const limitChanged = prevState.limit !== limit;
    const offsetChanged = prevState.offset !== offset;
    const { throttledFiltersChanged, filtersChanged } = getFilterChangeTypes(
      prevProps.filters,
      filters,
      {
        textFilterKeys: ['Product Name / HCPCS Code', 'Model'],
        immediateFilterKeys: [
          'Vendor ID',
          'Facility ID',
          'Category ID',
          'Custom',
          'Is Active',
          'Product ID',
        ],
      },
    );
    const sortByChanged = prevProps.sortBy !== sortBy;
    const sortChanged = prevProps.sort !== sort;
    if (throttledFiltersChanged) {
      this.onThrottledRequest();
    } else if (limitChanged || offsetChanged || filtersChanged || sortByChanged || sortChanged) {
      this.onRequest();
    } else if (inventory.length < count
      && this.scrollRef
      && this.scrollRef.scrollTop === 0
      && loading === 0) {
      this.onTableScroll({ target: this.scrollRef });
    }
  }

  onRequest() {
    const { actions, filters, sortBy, sort } = this.props;
    const { limit, offset } = this.state;
    const requestFilters = filters && Object.keys(filters).length > 0
      ? Object.keys(filters).map((key) => {
        let name;
        if (key === 'Product Name / HCPCS Code') {
          name = /^[A-Z]+\d{1,4}$/i.test(filters[key])
            ? 'HCPC Codes'
            : 'Product Name';
        } else {
          name = key;
        }
        if (key === 'Category ID') {
          return {
            name,
            operation: 'in',
            val: [filters[key]],
          };
        }
        if (key === 'Custom' && filters[key] === 'In Stock') {
          return {
            name: 'Stock Quantity',
            operation: 'gt',
            val: 0,
          };
        }
        if (key === 'Custom' && filters[key] === 'Frequently Used') {
          return {
            name: 'Recently Used',
            operation: 'le',
            val: 31,
          };
        }
        if (key === 'Custom' && filters[key] === 'Low Inventory') {
          return {
            name: 'Low Inventory',
            operation: 'le',
            val: 5,
          };
        }
        if (key === 'Custom' && filters[key] === 'Out Of Stock') {
          return {
            name: 'Stock Quantity',
            operation: 'eq',
            val: 0,
          };
        }
        if (key === 'Custom' && filters[key] === 'Backorder') {
          return {
            name: 'Stock Quantity',
            operation: 'lt',
            val: 0,
          };
        }
        if (key === 'Is Active') {
          return {
            name: 'Is Active',
            operation: 'eq',
            val: filters[key],
          };
        }
        if (key === 'Product ID') {
          return {
            name: 'ID',
            operation: 'eq',
            val: filters[key],
          };
        }
        return {
          name,
          operation: ['Vendor ID', 'Facility ID'].indexOf(key) === -1 ? 'startswith' : 'eq',
          val: key === 'Facility ID' && filters[key] === null ? filters[key] : filters[key].toString(),
          ...['Vendor ID', 'Facility ID'].indexOf(key) === -1 ? { case_sensitivity: false } : {},
          ...name === 'Product Name' ? { operation: 'contains' } : {},
        };
      })
      : [];
    actions.fetchInventories({
      limit,
      offset,
      filters: requestFilters,
      ...sortBy ? {
        sortBy: [{
          name: sortBy,
          sort,
        },
        {
          name: 'ID',
          sort: 'desc',
        }],
      } : {
        sortBy: [{
          name: 'ID',
          sort: 'desc',
        }],
      },
      triggerLoading: true,
      push: offset > 0,
    });
  }

  onCreateButtonClick() {
    this.setState({ inventoryCreateDialogOpen: true });
  }

  onInventoryCreateDialogEnter() {
    const { actions } = this.props;
    const { inventoryCreateFormValues } = this.state;
    if (inventoryCreateFormValues) {
      Object.keys(inventoryCreateFormValues).forEach((key) => {
        actions.change('inventoryCreate', key, inventoryCreateFormValues[key]);
      });
      this.setState({ inventoryCreateFormValues: null });
    }
  }

  onInventoryCreateDialogClose() {
    this.setState({ inventoryCreateDialogOpen: false });
  }

  onVendorCreate() {
    this.setState({
      inventoryCreateFormValues: this.props.inventoryCreateFormValues,
      inventoryCreateDialogOpen: false,
      vendorCreateDialogOpen: true,
    });
  }

  onVendorCreateDialogSubmitSuccess(values) {
    this.setState({
      vendorCreateDialogOpen: false,
      inventoryCreateDialogOpen: true,
      inventoryCreateFormValues: {
        ...this.state.inventoryCreateFormValues,
        ...{
          'Vendor Name': values['Vendor Name'],
          'Vendor ID': values.ID,
        },
      },
    });
  }

  onVendorCreateDialogClose() {
    this.setState({
      vendorCreateDialogOpen: false,
      inventoryCreateDialogOpen: true,
    });
  }

  onCategoryCreate() {
    this.setState({
      inventoryCreateFormValues: this.props.inventoryCreateFormValues,
      inventoryCreateDialogOpen: false,
      categoryCreateDialogOpen: true,
    });
  }

  onCategoryCreateDialogSubmitSuccess(values) {
    this.setState({
      categoryCreateDialogOpen: false,
      inventoryCreateDialogOpen: true,
      inventoryCreateFormValues: {
        ...this.state.inventoryCreateFormValues,
        ...{
          'Category Name': values.Name,
          'Category ID': values.ID,
        },
      },
    });
  }

  onCategoryCreateDialogClose() {
    this.setState({
      categoryCreateDialogOpen: false,
      inventoryCreateDialogOpen: true,
    });
  }

  onConditionCreate() {
    this.setState({
      inventoryCreateFormValues: this.props.inventoryCreateFormValues,
      inventoryCreateDialogOpen: false,
      conditionCreateDialogOpen: true,
    });
  }

  onConditionCreateDialogSubmitSuccess(values) {
    this.setState({
      conditionCreateDialogOpen: false,
      inventoryCreateDialogOpen: true,
      inventoryCreateFormValues: {
        ...this.state.inventoryCreateFormValues,
        ...{
          'Condition Name': values.Name,
          'Condition ID': values.ID,
        },
      },
    });
  }

  onConditionCreateDialogClose() {
    this.setState({
      conditionCreateDialogOpen: false,
      inventoryCreateDialogOpen: true,
    });
  }

  onWarehouseCreate() {
    this.setState({
      inventoryCreateFormValues: this.props.inventoryCreateFormValues,
      inventoryCreateDialogOpen: false,
      warehouseCreateDialogOpen: true,
    });
  }

  onWarehouseCreateDialogSubmitSuccess(values) {
    this.setState({
      warehouseCreateDialogOpen: false,
      inventoryCreateDialogOpen: true,
      inventoryCreateFormValues: {
        ...this.state.inventoryCreateFormValues,
        ...{
          'Warehouse Location': values.Location,
          'Warehouse ID': values.ID,
        },
      },
    });
  }

  onWarehouseCreateDialogClose() {
    this.setState({
      warehouseCreateDialogOpen: false,
      inventoryCreateDialogOpen: true,
    });
  }

  onSortingChange(actionSortBy) {
    const { actions, location, sort, sortBy } = this.props;
    let newSort;
    let newSortBy = actionSortBy;
    if (actionSortBy) {
      if (sortBy !== newSortBy) {
        newSort = 'asc';
      } else if (sort === 'asc') {
        newSort = 'desc';
      } else {
        newSortBy = null;
        newSort = null;
      }
    } else {
      newSortBy = null;
      newSort = null;
    }
    actions.addRouterParamsPageSettings({
      [location.pathname]: {
        sortBy: newSortBy,
        sort: newSort,
      },
    });
  }

  onMobileFilterBottonClick() {
    this.setState({ mobileFilterExpanded: !this.state.mobileFilterExpanded });
  }

  onTableScroll(event) {
    const { offset, limit } = this.state;

    if ((event.target.offsetHeight + event.target.scrollTop) / event.target.scrollHeight > 0.9) {
      if ((this.props.inventory.length - limit) >= offset) {
        this.setState({
          offset: offset + limit,
        });
      }
    }
  }

  render() {
    const {
      inventory,
      count,
      loading,
      sort,
      sortBy,
      business,
      filters,
      location,
      history,
    } = this.props;
    const {
      inventoryCreateDialogOpen,
      vendorCreateDialogOpen,
      categoryCreateDialogOpen,
      conditionCreateDialogOpen,
      warehouseCreateDialogOpen,
      mobileFilterExpanded,
    } = this.state;
    const params = qs.parse(location.search, { ignoreQueryPrefix: true });
    return (
      <Layout>
        <Helmet>
          <title>
            {appTitle} {titleSeparator} Inventory
          </title>
        </Helmet>
        <InventoryNavigation location={location} />
        <InventoryFilter
          form="inventoryFilter"
          onCreateButtonClick={this.onCreateButtonClick}
          onMobileFilterBottonClick={this.onMobileFilterBottonClick}
          mobileFilterExpanded={mobileFilterExpanded}
          filters={filters}
          loading={loading}
          count={count}
          items={inventory}
          destroyOnUnmount={false}
          {...filters['Product ID'] ? {
            initialValues: {
              'Selected Custom': 'All Inventory',
            },
          } : {}}
          onResetButtonClick={() => {
            if (params.ID) {
              history.replace(location.pathname);
            }
          }}
        />
        {loading > 0 &&
          <Progress fixed />
        }
        <InventoryTable
          items={inventory}
          count={count}
          sort={sort}
          sortBy={sortBy}
          onSortingChange={this.onSortingChange}
          loading={loading}
          business={business}
          mobileFilterExpanded={mobileFilterExpanded}
          onScroll={this.onTableScroll}
          scrollRef={(scrollRef) => { this.scrollRef = scrollRef; }}
          onProductCopySuccess={() => {
            this.onRequest();
          }}
        />
        <InventoryCreateEditDialog
          open={inventoryCreateDialogOpen}
          onEnter={this.onInventoryCreateDialogEnter}
          onClose={this.onInventoryCreateDialogClose}
          onVendorCreate={this.onVendorCreate}
          onCategoryCreate={this.onCategoryCreate}
          onConditionCreate={this.onConditionCreate}
          onWarehouseCreate={this.onWarehouseCreate}
          form="inventoryCreate"
          onSubmitSuccess={() => {
            this.onRequest();
          }}
        />
        <VendorCreateEditDialog
          form="vendorCreate"
          open={vendorCreateDialogOpen}
          onClose={this.onVendorCreateDialogClose}
          onSubmitSuccess={this.onVendorCreateDialogSubmitSuccess}
        />
        <InventoryCategoryCreateEditDialog
          form="inventoryCategoryCreate"
          open={categoryCreateDialogOpen}
          onClose={this.onCategoryCreateDialogClose}
          onSubmitSuccess={this.onCategoryCreateDialogSubmitSuccess}
        />
        <InventoryConditionCreateEditDialog
          form="inventoryConditionCreate"
          open={conditionCreateDialogOpen}
          onClose={this.onConditionCreateDialogClose}
          onSubmitSuccess={this.onConditionCreateDialogSubmitSuccess}
        />
        <InventoryWarehouseCreateEditDialog
          form="inventoryWarehouseCreate"
          open={warehouseCreateDialogOpen}
          onClose={this.onWarehouseCreateDialogClose}
          onSubmitSuccess={this.onWarehouseCreateDialogSubmitSuccess}
        />
      </Layout>
    );
  }
}

Inventory.propTypes = {
  inventory: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })).isRequired,
  count: PropTypes.number.isRequired,
  loading: PropTypes.number.isRequired,
  filters: PropTypes.shape({
    'Product Name / HCPCS Code': PropTypes.string,
    'Vendor ID': PropTypes.number,
    'Facility ID': PropTypes.number,
    'Category ID': PropTypes.number,
    Model: PropTypes.string,
    Custom: PropTypes.string,
    'Is Active': PropTypes.bool,
  }).isRequired,
  inventoryCreateFormValues: PropTypes.shape({
    'Product Name': PropTypes.string,
    Model: PropTypes.string,
  }),
  actions: PropTypes.shape({
    fetchInventories: PropTypes.func.isRequired,
    clearInventories: PropTypes.func.isRequired,
    addRouterParamsPageSettings: PropTypes.func.isRequired,
    fetchBusiness: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  limit: PropTypes.number,
  offset: PropTypes.number,
  sortBy: PropTypes.string,
  sort: PropTypes.oneOf(['asc', 'desc']),
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  width: PropTypes.string.isRequired,
};

Inventory.defaultProps = {
  inventoryCreateFormValues: {},
  limit: 10,
  offset: 0,
  sortBy: 'Product Name',
  sort: 'asc',
  business: {},
};

const mapStateToProps = (store, ownProps) => {
  const inventoryFilterValues = getFormValues('inventoryFilter')(store);
  const inventoryCreateFormValues = getFormValues('inventoryCreate')(store);
  const params = qs.parse(ownProps.location.search, { ignoreQueryPrefix: true });
  return {
    inventory: store.inventory.data,
    count: store.inventory.count,
    filters: {
      ...inventoryFilterValues
        && inventoryFilterValues['Product Name / HCPCS Code']
        ? { 'Product Name / HCPCS Code': inventoryFilterValues['Product Name / HCPCS Code'] }
        : {},
      ...inventoryFilterValues
        && inventoryFilterValues['Vendor ID']
        ? { 'Vendor ID': inventoryFilterValues['Vendor ID'] }
        : {},
      ...inventoryFilterValues
        && inventoryFilterValues['Facility ID'] !== undefined
        ? { 'Facility ID': inventoryFilterValues['Facility ID'] }
        : {},
      ...inventoryFilterValues
        && inventoryFilterValues['Category ID'] !== undefined
        && inventoryFilterValues['Category ID'] !== ''
        ? { 'Category ID': inventoryFilterValues['Category ID'] }
        : {},
      ...inventoryFilterValues
        && inventoryFilterValues.Model
        ? { Model: inventoryFilterValues.Model }
        : {},
      ...inventoryFilterValues
        && inventoryFilterValues['Selected Custom']
        && inventoryFilterValues['Selected Custom'] !== 'All Inventory'
        && !params.ID
        ? { Custom: inventoryFilterValues['Selected Custom'] }
        : {},
      ...inventoryFilterValues
        && inventoryFilterValues['Selected Status']
        && inventoryFilterValues['Selected Status'] === 'Active'
        ? { 'Is Active': true }
        : {},
      ...inventoryFilterValues
        && inventoryFilterValues['Selected Status']
        && inventoryFilterValues['Selected Status'] === 'Inactive'
        ? { 'Is Active': false }
        : {},
      ...params.ID ? { 'Product ID': Number(params.ID) } : {},
    },
    loading: store.inventory.loading,
    inventoryCreateFormValues,
    ...store.routerParams.pageSettings[ownProps.location.pathname],
    business: store.business.data,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchInventories,
    clearInventories,
    addRouterParamsPageSettings,
    fetchBusiness,
    change,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withWidth()(Inventory));



// WEBPACK FOOTER //
// ./src/pages/inventory/Inventory.js